export default __webpack_public_path__ + "static/media/avatar-4.4a140370.jpg";